module.exports = __webpack_public_path__ + "img/subscription1.96c1af81.png";